import { render, staticRenderFns } from "./InventoryLocationModal.vue?vue&type=template&id=380b2cee&"
import script from "./InventoryLocationModal.vue?vue&type=script&lang=js&"
export * from "./InventoryLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports